<script>
import Section from '../../components/PageSection'
import Modale from "../../components/Modale"
import ModalYesNo from "../../components/ModalYesNo"

export default {
  name: 'application',
    components :{
    Section,
    Modale,
    ModalYesNo,
  },
  data(){
    return{
      ressources: [],
      roles: [],
      droits: [],
      isModaleAddRessourceVisible: false,
      modaleInfos: {}, //Si je doit déclarer certaines propriétés dans data, bien les déclarer également dans closeModale()
    }
  },
  async mounted(){
    const promiseRessources = this.$axios.get('ressources').then(response => this.ressources = response.data).catch(err => this.alert(err))
    const promiseRoles      = this.$axios.get('roles/getByAgence/' + this.$store.state.auth.currentAgence._id).then(response => this.roles = response.data).catch(err => this.alert(err))
    const promiseDroits     = this.$axios.get('droits/getByAgence/' + this.$store.state.auth.currentAgence._id).then(response => this.droits = response.data).catch(err => this.alert(err))

    await Promise.all([promiseRessources,promiseRoles,promiseDroits])

    let role1Id = this.roles[0]._id
    let role2Id = this.roles[1]._id
    let role3Id = this.roles[2]._id

    for (let [index, item] of this.ressources.entries()){
      let isOk

      isOk = this.droits.find(e => e.roleId == role1Id && e.ressourceId == item._id)
      this.$set(this.ressources[index], 'lecture1', (isOk) ? isOk.lecture : false)
      isOk = this.droits.find(e => e.roleId == role2Id && e.ressourceId == item._id)
      this.$set(this.ressources[index], 'lecture2', (isOk) ? isOk.lecture : false)
      isOk = this.droits.find(e => e.roleId == role3Id && e.ressourceId == item._id)
      this.$set(this.ressources[index], 'lecture3', (isOk) ? isOk.lecture : false)
      isOk = this.droits.find(e => e.roleId == role1Id && e.ressourceId == item._id)
      this.$set(this.ressources[index], 'ecriture1', (isOk) ? isOk.ecriture : false)
      isOk = this.droits.find(e => e.roleId == role2Id && e.ressourceId == item._id)
      this.$set(this.ressources[index], 'ecriture2', (isOk) ? isOk.ecriture : false)
      isOk = this.droits.find(e => e.roleId == role3Id && e.ressourceId == item._id)
      this.$set(this.ressources[index], 'ecriture3', (isOk) ? isOk.ecriture : false)
    }
  },
  computed:{
    permissions(){
      let payload = []

      return payload
    },
  },
  methods:{
    update(role, ressourceId, arg, value){
      let item = {
        ressourceId: ressourceId,
      }

      item[arg] = value;

      this.$axios.put('droits/allByName/' + role + '/' + ressourceId, item)
      .then(response => console.log(response.data))
      .catch(err => this.alert(err))
    },
    // Ajouter une nouvelle ressource
    addRessource(){
      if (this.modaleInfos.short && this.modaleInfos.name){
        let item = {
          short:    this.modaleInfos.short,
          name:     this.modaleInfos.name,
          detail:   this.modaleInfos.details,
        }

        console.log(item)

        this.$axios.post('ressources/register/', item)
        .then(res => {
          this.alert(res)
          this.closeModale();
          })
        .catch(err => this.alert(err))

      } else {
        this.alert("Tous les champs ne sont pas valides")
      }
    },
    closeModale(){
      this.isModaleAddRessourceVisible = false;
      this.modaleInfos = {}
    }
  }
}
</script>


<template>
  <div>
    <!-- Add Ressource -->
      <Modale v-if="isModaleAddRessourceVisible" @close="closeModale">
        <template v-slot:header>
          <span>Ajouter une ressource</span>
        </template>
        <template v-slot:body>
          <div class="modale-addRessource-line"><label for="short">Short : </label><input v-model="modaleInfos.short" type="text" name="short"></div>
          <div class="modale-addRessource-line"><label for="name">Name : </label><input v-model="modaleInfos.name" type="text" name="name"></div>
          <div class="modale-addRessource-line"><label for="detail">Détails : </label><input v-model="modaleInfos.details" type="text" name="details"></div>
        </template>
        <template v-slot:footer>
          <ModalYesNo @no="closeModale" @yes="addRessource"></ModalYesNo>
        </template>
      </Modale>
    
    <Section text="Droits utilisateurs">
      <template v-slot:body>
        <div class="droitsUsers">
          <div class="droitsUsers__grid">
            <p class="droitsUsers__title" style="text-align:left;">Ressources</p>
            <p v-for="item in roles" :key="item._id"       class="droitsUsers__title"> {{item.name}} Lecture</p>
            <p v-for="item in roles" :key="item._id + 'b'" class="droitsUsers__title"> {{item.name}} Ecriture</p>
          </div>  
          <div class="droitsUsers__grid" v-for="item in ressources" :key="item._id">
            <div class="droitsUsers__item"> {{item.name}} </div>
            <input type="checkbox" v-model="item.lecture1"  @change="update(roles[0].name, item._id, 'lecture', item.lecture1)">
            <input type="checkbox" v-model="item.lecture2"  @change="update(roles[1].name, item._id, 'lecture', item.lecture2)">
            <input type="checkbox" v-model="item.lecture3"  @change="update(roles[2].name, item._id, 'lecture', item.lecture3)">
            <input type="checkbox" v-model="item.ecriture1" @change="update(roles[0].name, item._id, 'ecriture', item.ecriture1)">
            <input type="checkbox" v-model="item.ecriture2" @change="update(roles[1].name, item._id, 'ecriture', item.ecriture2)">
            <input type="checkbox" v-model="item.ecriture3" @change="update(roles[2].name, item._id, 'ecriture', item.ecriture3)">
          </div>
          <p class="droitsUsers__note">Super Admin : 60faa2b5dc64f75e1853a384</p>
          <button class="droitsUsers__addButton" @click="isModaleAddRessourceVisible = true">Ajouter une ressource</button>
        </div>
      </template>
    </Section>

    <Section text="Définition des ressources">

    </Section>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';
.droitsUsers{
  &__grid{
    display: grid;
    grid-template-columns: 300px repeat(6, 100px);
  }

  &__title{
    @include myFont;
    color: $main;
    font-size: 13px;
    text-align: center;
  }

  &__item{
    @include myFont;
    font-size: 13px;
  }

  &__note{
    @include myFont;
    color: $black;
    font-size: 13px;
  }

  &__addButton{
    @include myButton;
    margin: 0 0 15px 0;
  }
}

.modale{
  &-addRessource{
    &-line{
      & label{
        display: inline-block;
        width: 50px;
        margin: 5px;
      }

      & input{
        width: 300px;
      }
    }
  }
}

</style>
